import React from 'react';
import { Home, Search, Plus, MessageCircle, User } from 'lucide-react';
interface MobileNavProps {
  activeTab: 'home' | 'search' | 'create' | 'messages' | 'profile';
  onTabChange: (tab: 'home' | 'search' | 'create' | 'messages' | 'profile') => void;
  onCreateClick: () => void;
}
export function MobileNav({
  activeTab,
  onTabChange,
  onCreateClick
}: MobileNavProps) {
  const handleCreateClick = () => {
    onTabChange('create');
    onCreateClick();
  };
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 px-6 py-3 md:hidden z-40 flex justify-between items-center pb-safe" data-id="element-161">
      <button onClick={() => onTabChange('home')} className={`p-2 transition-colors ${activeTab === 'home' ? 'text-black' : 'text-gray-400'}`} data-id="element-162">
        <Home className="w-6 h-6" data-id="element-163" />
      </button>
      <button onClick={() => onTabChange('search')} className={`p-2 transition-colors ${activeTab === 'search' ? 'text-black' : 'text-gray-400'}`} data-id="element-164">
        <Search className="w-6 h-6" data-id="element-165" />
      </button>
      <button onClick={handleCreateClick} className="p-3 bg-black text-white rounded-full -mt-6 shadow-lg hover:scale-105 active:scale-95 transition-transform" data-id="element-166">
        <Plus className="w-6 h-6" data-id="element-167" />
      </button>
      <button onClick={() => onTabChange('messages')} className={`p-2 transition-colors ${activeTab === 'messages' ? 'text-black' : 'text-gray-400'}`} data-id="element-168">
        <MessageCircle className="w-6 h-6" data-id="element-169" />
      </button>
      <button onClick={() => onTabChange('profile')} className={`p-2 transition-colors ${activeTab === 'profile' ? 'text-black' : 'text-gray-400'}`} data-id="element-170">
        <User className="w-6 h-6" data-id="element-171" />
      </button>
    </div>;
}